import axios from 'axios';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: process.env.REACT_APP_BASE_API });

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log('error', error.response);
    if (error?.response?.status === 401) {
      /*   window.location.reload(); */
    }
    return Promise.reject((error.response && error.response.data) || 'Something went wrong');
  }
);

export default axiosInstance;
